export enum EditRowState {
	New = 'new',
	Editing = 'editing',
	Saved = 'saved',
	Viewing = 'viewing',
	Removed = 'removed',
	Draft = 'draft',
}